export const googleRating = {
  score: '4,7',
  value: 4.7,
  count: 47,
};

export const heroStats = [
  { value: '300+', label: 'Aufträge' },
  { value: '7 Jahre', label: 'Erfahrung' },
  { value: '40+', label: 'Kunden' },
  { value: 'IHK', label: 'zertifiziert' },
];
